<script>
export default {
    name: "p-input",
    props: ['value','name','label','type', 'mask', 'minlength', 'maxlength', 'required', 'validate', 'error'],
    data() {
        return {
            filterIsActive: false
        }
    },
    methods: {
        updateData(value) {
            this.$emit('input', value)
        }
    },
    computed: {
        inputListeners: function () {
            var vm = this
            return Object.assign({},
            this.$listeners,{
                input: function (event) {
                    vm.$emit('input', event.target.value)
                }
            })
        }
    }, 
    created: function() {}
}
</script>
<template>
    <div class="p-input field" :class="{active: filterIsActive}">
        <label :for="name" class="label">
            <span>{{label}}:</span>
        </label>
        <div class="inner" :class="{ error: error }">
            <input :id="name" v-if="mask" :value="value"  :validate="validate" :required="required" :minlength="minlength" :maxlength="maxlength" v-mask="mask" :type="type" :name="name" :data-name="label" ref="textPicker" v-on="inputListeners" class="input" @focus="filterIsActive = true" @blur="filterIsActive = false" />
            <input :id="name" v-if="!mask" :value="value" :validate="validate" :required="required" :minlength="minlength" :maxlength="maxlength" :type="type" :name="name" :data-name="label" ref="textPicker" v-on="inputListeners" class="input" @focus="filterIsActive = true" @blur="filterIsActive = false" />
        </div>
        <span class="error-status">{{error}}</span>
    </div>
</template>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/js/components/p-input.vue